export const REQUEST = actionTypeName => actionTypeName + "_REQ";
export const SUCCESS = actionTypeName => actionTypeName + "_RESP";
export const ERROR = actionTypeName => actionTypeName + "_ERR";
